import { useCallback, useEffect, useRef, useState } from "react";
import { api, isBusy } from "./api";

export function useFetch(url, interval = 0, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const retry = useRef(null);
  const load = useCallback(async () => {
    if (!url) return;
    clearTimeout(retry.current);
    try { const r = await api.get(url); setData(r.data); setError(null); setLoading(false); }
    catch (e) {
      setError(e);
      if (isBusy(e)) retry.current = setTimeout(load, 5000);
      else setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  useEffect(() => {
    load();
    const id = interval ? setInterval(load, interval) : null;
    return () => { clearInterval(id); clearTimeout(retry.current); };
  }, [load, interval]);
  return { data, error, loading, reload: load, setData };
}
